import { navigateToChangeInsightDetails } from '../../links/index.jsx';

export const resetFilters = (initiativeId, initiativeType) => {
  const query = {
    employeeIds: [],
    groupIds: [],
    statuses: [],
    organizationStakeholderIds: [],
    stakeholder: [],
    participant: [],
  };

  navigateToChangeInsightDetails(query, initiativeId, initiativeType);
};
